function initScrollToTopBtn() {
    const btnBackToTop = document.querySelector(".scroll-to-top");
    if (btnBackToTop) {
        window.addEventListener("scroll", function() {
            if (window.scrollY > 200) {
                btnBackToTop.classList.add("scroll-to-top--show");
            } else {
                btnBackToTop.classList.remove("scroll-to-top--show");
            }
        });

        btnBackToTop.addEventListener("click", function(event) {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    }
}

window.addEventListener("load", () => {
    initScrollToTopBtn();
});

